const EXPLORER_BASE_URLS = {
  BTC: "https://www.blockchain.com/btc/address/",
  ETH: "https://etherscan.io/address/",
  LTC: "https://live.blockcypher.com/ltc/address/",
  BCH: "https://www.blockchain.com/bch/address/"
};

const getBlockexplorerLink =  (type, address) => EXPLORER_BASE_URLS[type] + address;
export default getBlockexplorerLink;

